const UPDATE_APP_PRODUCTCODE = 'UPDATE_APP_PRODUCTCODE'
const UPDATE_APP_INNERCODE = 'UPDATE_APP_INNERCODE'
const UPDATE_APP_H5 = 'UPDATE_APP_H5'

const UPDATE_ORDER_UNIONCODE = 'UPDATE_ORDER_UNIONCODE'
const UPDATE_ORDER_CONFIRMFEEDBACK = 'UPDATE_ORDER_CONFIRMFEEDBACK'
const UPDATE_ORDER_PAYMENTMODE = 'UPDATE_ORDER_PAYMENTMODE'
const UPDATE_ORDER_OFFLINECODE = 'UPDATE_ORDER_OFFLINECODE'
const UPDATE_CONFIG = 'UPDATE_CONFIG'

const UPDATE_MEASURESUCCESS = 'UPDATE_MEASURESUCCESS'
const UPDATE_BASEPREMIUM = 'UPDATE_BASEPREMIUM'
const UPDATE_BASEBACKMONEY = 'UPDATE_BASEBACKMONEY'

const UPDATE_FEESUCCESS = 'UPDATE_FEESUCCESS'

const UPDATE_INSUREDRELATION = 'UPDATE_INSUREDRELATION'
const UPDATE_BIRTHDAY = 'UPDATE_BIRTHDAY'
const UPDATE_SEX = 'UPDATE_SEX'
const UPDATE_COVERAGE = 'UPDATE_COVERAGE'
const UPDATE_PAYMENTPERIOD = 'UPDATE_PAYMENTPERIOD'
const UPDATE_INSURANCEPERIOD = 'UPDATE_INSURANCEPERIOD'
const UPDATE_PAYMENTWAY = 'UPDATE_PAYMENTWAY'
const UPDATE_MILD = 'UPDATE_MILD'
const UPDATE_INSUREDNAME = 'UPDATE_INSUREDNAME'
const UPDATE_INSUREDIDNUMBER = 'UPDATE_INSUREDIDNUMBER'
const UPDATE_INSUREDHEIGHT = 'UPDATE_INSUREDHEIGHT'
const UPDATE_INSUREDWEIGHT = 'UPDATE_INSUREDWEIGHT'
const UPDATE_ISINSUREDIDLONGTERM = 'UPDATE_ISINSUREDIDLONGTERM'
const UPDATE_INSUREDIDBEGINTERM = 'UPDATE_INSUREDIDBEGINTERM'
const UPDATE_INSUREDIDENDTERM = 'UPDATE_INSUREDIDENDTERM'
const UPDATE_INSUREDOCCUPATION = 'UPDATE_INSUREDOCCUPATION'
const UPDATE_HOLDERNAME = 'UPDATE_HOLDERNAME'
const UPDATE_HOLDERPHONE = 'UPDATE_HOLDERPHONE'
const UPDATE_HOLDERPHONECAPTCHA = 'UPDATE_HOLDERPHONECAPTCHA'
const UPDATE_HOLDEREMAIL = 'UPDATE_HOLDEREMAIL'
const UPDATE_HOLDERAREA = 'UPDATE_HOLDERAREA'
const UPDATE_HOLDERADDRESS = 'UPDATE_HOLDERADDRESS'
const UPDATE_HOLDERIDNUMBER = 'UPDATE_HOLDERIDNUMBER'
const UPDATE_ISHOLDERIDLONGTERM = 'UPDATE_ISHOLDERIDLONGTERM'
const UPDATE_HOLDERIDBEGINTERM = 'UPDATE_HOLDERIDBEGINTERM'
const UPDATE_HOLDERIDENDTERM = 'UPDATE_HOLDERIDENDTERM'
const UPDATE_HOLDEROCCUPATION = 'UPDATE_HOLDEROCCUPATION'
const UPDATE_BANKSFROMSERVER = 'UPDATE_BANKSFROMSERVER'
const UPDATE_RAWBANKSFROMSERVER = 'UPDATE_RAWBANKSFROMSERVER'

export default {
  UPDATE_APP_PRODUCTCODE,
  UPDATE_APP_INNERCODE,
  UPDATE_APP_H5,

  UPDATE_ORDER_UNIONCODE,
  UPDATE_ORDER_CONFIRMFEEDBACK,
  UPDATE_ORDER_PAYMENTMODE,
  UPDATE_ORDER_OFFLINECODE,

  UPDATE_MEASURESUCCESS,
  UPDATE_BASEPREMIUM,
  UPDATE_BASEBACKMONEY,

  UPDATE_FEESUCCESS,

  UPDATE_CONFIG,
  UPDATE_BANKSFROMSERVER,
  UPDATE_RAWBANKSFROMSERVER,

  UPDATE_INSUREDRELATION,
  UPDATE_BIRTHDAY,
  UPDATE_SEX,
  UPDATE_COVERAGE,
  UPDATE_PAYMENTPERIOD,
  UPDATE_INSURANCEPERIOD,
  UPDATE_PAYMENTWAY,
  UPDATE_MILD,
  UPDATE_INSUREDNAME,
  UPDATE_INSUREDIDNUMBER,
  UPDATE_INSUREDHEIGHT,
  UPDATE_INSUREDWEIGHT,
  UPDATE_ISINSUREDIDLONGTERM,
  UPDATE_INSUREDIDBEGINTERM,
  UPDATE_INSUREDIDENDTERM,
  UPDATE_INSUREDOCCUPATION,
  UPDATE_HOLDERNAME,
  UPDATE_HOLDERPHONE,
  UPDATE_HOLDERPHONECAPTCHA,
  UPDATE_HOLDEREMAIL,
  UPDATE_HOLDERAREA,
  UPDATE_HOLDERADDRESS,
  UPDATE_HOLDERIDNUMBER,
  UPDATE_ISHOLDERIDLONGTERM,
  UPDATE_HOLDERIDBEGINTERM,
  UPDATE_HOLDERIDENDTERM,
  UPDATE_HOLDEROCCUPATION
}



// WEBPACK FOOTER //
// ./src/store/mutation-types.js